import { parseDomain } from './parse-domain';
import { SettingsCookie } from './settings-cookie';

export function goToLastPage(): void {
   window.location.assign(getLastPage());
}

export function getLastPage(): string {
   // If this was opened in a new window (e.g., target="_blank" rel="noreferrer"), then
   // close it and refresh the original window. The assumption is that this
   // behavior is more desirable that redirecting to last viewed page if
   // the query parameter close_after is set.
   if (
      new URLSearchParams(window.location.search).get('close_after') === '1' &&
      window.opener &&
      window.opener.location.hostname === window.location.hostname
   ) {
      window.opener.location.reload();
      window.close();
   }

   const loc = SettingsCookie.get('last_page') || '/';

   let decoded;
   try {
      decoded = decodeURIComponent(loc);
   } catch {
      return '/';
   }

   return isSafeRedirect(decoded) ? decoded : '/';
}

function isSafeRedirect(url: string): boolean {
   let parsed;
   try {
      parsed = new URL(url, window.location.origin);
   } catch {
      return false;
   }

   if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
      return false;
   }

   const currentDomain = parseDomain()['domain'];
   return (
      parsed.hostname === window.location.hostname || parsed.hostname.endsWith(`.${currentDomain}`)
   );
}
